import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Select,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Checkbox,
} from '@chakra-ui/react';
import React from 'react';
import { Controller } from 'react-hook-form';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { t } from 'i18next';

const ESelect = ({
  label,
  name,
  placeholder,
  control,
  dataSelect,
  style,
  disabled = false,
  isMulti = false,
  ...rest
}) => {
  return (
    <Controller
      control={control}
      name={name}
      {...rest}
      render={({ field, fieldState: { error } }) => {
        if (isMulti) {
          const currentValues = Array.isArray(field.value)
            ? field.value
            : field.value
            ? [field.value]
            : [];

          // Filter valid items (non-empty)
          const validItems = dataSelect?.filter(
            (item) => item.id !== "" && item.id != null && item.name !== "" && item.name != null
          ) || [];

          const allIds = validItems.map((item) => String(item.id));
          const allSelected = allIds.length > 0 && allIds.every((id) => currentValues.includes(id));
          const someSelected = currentValues.length > 0 && currentValues.length < allIds.length;

          const toggleValue = (value) => {
            if (disabled) return;
            const valueStr = String(value);
            if (currentValues.includes(valueStr)) {
              field.onChange(currentValues.filter((v) => v !== valueStr));
            } else {
              field.onChange([...currentValues, valueStr]);
            }
          };

          const toggleAll = () => {
            if (disabled) return;
            if (allSelected) {
              // Unselect all
              field.onChange([]);
            } else {
              // Select all
              field.onChange(allIds);
            }
          };

          const selectedLabels = validItems
            ?.filter((item) => currentValues.includes(String(item.id)))
            .map((item) => item.name);
          const renderButtonLabel = () => {
            if (!selectedLabels || selectedLabels.length === 0) {
              return placeholder;
            }
            if (selectedLabels.length <= 2) {
              return selectedLabels.join(", ");
            }
            const [first, second] = selectedLabels;
            return `${first}, ${second}, ... +${selectedLabels.length - 2}`;
          };

          return (
            <FormControl isInvalid={!!error}>
              {label && <FormLabel>{label}</FormLabel>}
              <Menu closeOnSelect={false}>
                <MenuButton
                  as={Button}
                  rightIcon={<ChevronDownIcon boxSize="20px" />}
                  width="100%"
                  textAlign="left"
                  fontSize="14px"
                  fontWeight="normal"
                  variant="outline"
                  paddingRight="9px !important"
                  isDisabled={disabled}
                  borderWidth={error ? "2px" : "1px"}
                  borderColor={error ? "red.500" : undefined}
                  _hover={{
                    borderColor: error ? "red.500" : undefined,
                    borderWidth: error ? "2px" : "1px",
                  }}
                  _focus={{
                    borderColor: error ? "red.500" : undefined,
                    borderWidth: "1px",
                    boxShadow: error ? "0 0 0 1px var(--chakra-colors-red-500)" : undefined,
                  }}
                >
                  {renderButtonLabel()}
                </MenuButton>
                <MenuList maxH="240px" overflowY="auto" zIndex={9}>
                  <MenuItem
                    closeOnSelect={false}
                    onClick={toggleAll}
                  >
                    <Checkbox 
                      isChecked={allSelected} 
                      isIndeterminate={someSelected}
                      pointerEvents="none"
                    >
                      {allSelected ? t("common.uncheck_all") : t("common.check_all")}
                    </Checkbox>
                  </MenuItem>
                  {validItems.map((item, index) => {
                    const idStr = String(item.id);
                    const isChecked = currentValues.includes(idStr);
                    return (
                      <MenuItem
                        key={index}
                        closeOnSelect={false}
                        onClick={() => toggleValue(idStr)}
                      >
                        <Checkbox isChecked={isChecked} pointerEvents="none">
                          {item.name}
                        </Checkbox>
                      </MenuItem>
                    );
                  })}
                </MenuList>
              </Menu>
              <FormErrorMessage fontSize={"14px"}>{error && error.message}</FormErrorMessage>
            </FormControl>
          );
        }

        const handleChange = (event) => {
          field.onChange(event.target.value);
        };

        const value = field.value ?? '';

        return (
          <FormControl isInvalid={!!error}>
            {label && <FormLabel>{label}</FormLabel>}
            <Select
              {...field}
              value={value}
              onChange={handleChange}
              placeholder={placeholder}
              fontSize={'14px'}
              sx={style}
              disabled={disabled}
            >
              {dataSelect?.map((item, index) => (
                <option key={index} value={item.id}>
                  {item.name}
                </option>
              ))}
            </Select>
            <FormErrorMessage>{error && error.message}</FormErrorMessage>
          </FormControl>
        );
      }}
    />
  );
};

export default ESelect;